import { Injectable } from "@angular/core";
import { User } from "src/app/models/user";
import { HttpClient, HttpHeaders } from "@angular/common/http";
//import { Store } from 'src/app/models/store';
import { Retailer } from "src/app/models/Retailer";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
//import { map } from 'rxjs/operators';
//import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: "root",
})
export class UserInfoService {
  private currentUser: User = null;
  private lastCall: Date = new Date();
  private timeOutMinutes: number = 120; //2 hours
  private mockUserDataUrl = "assets/data/mock-user.json";

  selectedRetailCompany: BehaviorSubject<Retailer> = new BehaviorSubject(null);
  selectedRetailCompany$: Observable<Retailer> =
    this.selectedRetailCompany.asObservable();

  constructor(private http: HttpClient) {}

  getUserInformation(): Observable<User> {
    // If in development mode, return the local mock data
    if (environment.production === false) {
      return this.http.get<any>(this.mockUserDataUrl);
    }

    return this.http.get<any>("/api/login");
  }

  setSelectedRetialCompany(newRetailCompany: Retailer) {
    this.selectedRetailCompany.next(newRetailCompany);
  }

  getCurrentUser(): User {
    return this.currentUser;
  }

  setCurrentUser(newUser: User) {
    this.currentUser = newUser;
  }

  logoutUser() {
    const formdata: FormData = new FormData();
    const url = "/api/logout";
    console.log("logoutUser");
    return this.http.post(url, formdata);
  }

  //this is for timing out programtically.
  isTimeout(): boolean {
    let diffMs = new Date().getTime() - this.lastCall.getTime();
    let diffMins = Math.floor(diffMs / 1000 / 60); // minutes
    //console.log(new Date() + " diffMs: " + diffMs + " diffMins: " + diffMins);
    if (diffMins < this.timeOutMinutes) {
      this.lastCall = new Date();
      return false;
    } else {
      return true;
    }
  }
}
